import { LiquidityScenario, LiquidityScenarioHead,  LiquidityScenarioTransaction,  NewLiquidityScenario, UpdateLiquidityScenario, UpdateLiquidityScenarioHead  } from '@/types/liquidity-api';
import {api, withErrorHandling} from './api';

export const getLiquidityScenarioHeads = async (clientId: string, connectionId: string): Promise<Array<LiquidityScenarioHead>> => {
	console.log('Fetching liquidity scenarios:');
	const response = await withErrorHandling(() => api.get<Array<LiquidityScenarioHead>>(`/clients/${clientId}/connections/${connectionId}/liquidityscenarios`));
	console.log('Liquidity scenario response:', response.data);
	return response.data;
};

export const getLiquidityScenarioById = async (liquidityScenarioId?: string): Promise<LiquidityScenario> => {
	console.log('Fetching liquidity scenario:', liquidityScenarioId);
	const response = await withErrorHandling(() => api.get<LiquidityScenario>(`/liquidityscenarios/${liquidityScenarioId}`));
	console.log('Liquidity scenario response:', response.data);
	return validateResponseData(response.data);
};

export const createLiquidityScenario = async (liquidityScenario: NewLiquidityScenario): Promise<LiquidityScenario> => {
	console.log('Creating liquidity scenario:', liquidityScenario);
	const response = await withErrorHandling(() => api.post<LiquidityScenario>("/liquidityscenarios", liquidityScenario));
	console.log('Create liquidity scenario response:', response.data);
	return validateResponseData(response.data);
};

export const updateLiquidityScenarioHead = async (liquidityScenarioId: string, liquidityScenario: UpdateLiquidityScenarioHead) => {
	console.log('Updating liquidity scenario head:', liquidityScenarioId);
	const response = await withErrorHandling(() => api.put(`/liquidityscenarios/${liquidityScenarioId}`, liquidityScenario));
	console.log('Update liquidity scenario head response:', response.data);
	return response.data;
}

export const updateLiquidityScenarioTransactions = async (liquidityScenarioId: string, transactions: Array<LiquidityScenarioTransaction>) => {
	console.log('Updating liquidity scenario transactions:', liquidityScenarioId);
	const transactionsObj = {
		transactions: transactions
	}
	const response = await withErrorHandling(() => api.put(`/liquidityscenarios/${liquidityScenarioId}/transactions`, transactionsObj));
	console.log('Update liquidity scenario transactions response:', response.data);
	return validateResponseData(response.data);
}

export const deleteLiquidityScenarioById = async (liquidityScenarioId: string) => {
	console.log('Deleting liquidity scenario:', liquidityScenarioId);
	const response = await withErrorHandling(() => api.delete(`/liquidityscenarios/${liquidityScenarioId}`));
	console.log('Delete liquidity scenario response:', response.data);
	return response.data;
}

const validateResponseData = (scenario: LiquidityScenario): LiquidityScenario => {
	if (scenario.transactions) {
		return scenario;
	} else {
		return {...scenario, transactions: []}
	}
} 